import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminRecruitments = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENTS.GET_ALL, { params });
    return response.data;
};
export const getAdminRecruitmentById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENTS.GET_BY_ID(id));
    return response.data;
};
export const createRecruitment = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.RECRUITMENTS.CREATE, data);
    return response.data;
};
export const updateRecruitment = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.RECRUITMENTS.UPDATE(id), data);
    return response.data;
};
export const deleteRecruitment = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.RECRUITMENTS.DELETE(id));
    return response.data;
};

